import { z } from 'zod'

import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

import { BidIdSchema } from '../unique-id.models.ts'
import { SurveyFeedbackSchema } from './common.ts'
import { SurveyTypeSchema } from './survey-types.ts'

export const [
  MakerBidAcceptedByBrandReasons,
  MakerBidAcceptedByBrandReasonSchema,
  MakerBidAcceptedByBrandReasonEnum,
] = EnumBuilder(
  'relevant-examples-past-work',
  'expert-in-required-skillset',
  'within-budget',
  'great-past-experience-with-maker',
  'excellent-pitch',
  'in-ideal-location-fluent-in-required-language',
  'other'
)

export type MakerBidAcceptedByBrandReason = ZodInfer<
  typeof MakerBidAcceptedByBrandReasonSchema
>

export const MakerBidAcceptedByBrandResponsesSchema = z.discriminatedUnion(
  'reason',
  [
    z.object({
      reason: MakerBidAcceptedByBrandReasonSchema.extract(['other']),
      feedback: SurveyFeedbackSchema,
    }),
    z.object({
      reason: MakerBidAcceptedByBrandReasonSchema.exclude(['other']),
      feedback: SurveyFeedbackSchema.optional(),
    }),
  ]
)

export type MakerBidAcceptedByBrandResponses = ZodInfer<
  typeof MakerBidAcceptedByBrandResponsesSchema
>

export const MakerBidAcceptedByBrandSurveyDetailsSchema = z.object({
  surveyType: SurveyTypeSchema.extract(['maker-bid-accepted-by-brand']),
  bidId: BidIdSchema,
  responses: MakerBidAcceptedByBrandResponsesSchema,
})
